import React, { useCallback, useState } from 'react';
import { Box, DialogContent, Typography, Button } from '@material-ui/core';

import { FormStatus, PaymentMethodForms, paymentMethodService } from '@lib/state';
import { AddPaymentMethodForm, StyledDialog, LoadingIndicator } from '../../components';
import { getAcceptCardData } from '../../utils';
import { useFormEvents } from '../../forms';
import { PaymentFields } from '../../components/forms/add-payment-method.form';

interface Props {
  onClose: () => void;
}

export const AddPaymentMethodModal: React.FC<Props> = ({ onClose }) => {
  const [{ status, error }] = useFormEvents(PaymentMethodForms.AddPaymentMethod);

  const onSubmit = useCallback(({ billing, card }: PaymentFields) => {
    if (billing && card) {
      paymentMethodService.addPaymentMethod(billing.name, billing.address, getAcceptCardData(card));
    }
  }, []);

  return (
    <StyledDialog title="Add Payment Method" open={true} onClose={onClose}>
      <DialogContent>
        {[FormStatus.Initial, FormStatus.Error].includes(status) && (
          <AddPaymentMethodForm
            status={status}
            error={error}
            onSubmit={onSubmit}
            onCancel={onClose}
          ></AddPaymentMethodForm>
        )}
        {status === FormStatus.Success && (
          <Box p={1} fontSize="125%" textAlign="center">
            <Typography>Payment method added</Typography>
            <Button color="secondary" variant="contained" onClick={onClose}>
              Close
            </Button>
          </Box>
        )}
        {status === FormStatus.Pending && <LoadingIndicator />}
      </DialogContent>
    </StyledDialog>
  );
};

export const AddPaymentMethodButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="text" color="primary" size="small">
        Add Payment Method
      </Button>
      {open === true ? <AddPaymentMethodModal onClose={closeDialog}></AddPaymentMethodModal> : null}
    </>
  );
};
